export const SNS_TYPE_NAME = {
  kakao: '카카오톡',
  line: '라인',
  facebook: '페이스북',
  twitter: '트위터',
};
